<script setup>
import {mdiAlert} from "@mdi/js";
import {useTitle} from "@/utils/metadata";

useTitle(pgettext('title', 'Member not active'));
</script>

<template>
    <v-empty-state :icon="mdiAlert"
                   :headline="gettext('Your account has been deactivated')"
                   :title="gettext('Please contact your dispatching center.')">
        <template #actions>
            <v-btn :href="reverseUrl('web:hpo:sign_in_form')" color="red">
                HPO
            </v-btn>
        </template>
    </v-empty-state>
</template>
